import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { UnsavedChangeService } from '../services';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const UnsavedChangeGuard: CanDeactivateFn<unknown> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  const service = inject(UnsavedChangeService);
  return service.regGuideHasUnsavedChanges()
    ? service.triggerNavigation()
    : true;
};
